import PropTypes from 'prop-types';
import React from 'react';

const SelectMultiValue = ({
  selectedCount,
  selectedOptions,
  singularLabel,
  pluralLabel,
  allSelectedLabel,
  optionsCount
}) => {
  const description = selectedCount > 1 ? pluralLabel : singularLabel;
  const allSelected = selectedCount === optionsCount;
  if (allSelected) {
    return <span>{allSelectedLabel}</span>;
  }
  return (
    <span>
      {selectedCount} {description}
    </span>
  );
};

SelectMultiValue.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  singularLabel: PropTypes.string.isRequired,
  pluralLabel: PropTypes.string.isRequired,
  allSelectedLabel: PropTypes.string.isRequired
};

SelectMultiValue.displayName = 'SelectMultiValue';

export default SelectMultiValue;
